module.exports = __webpack_public_path__ + "static/img/06ye.aebce77a.gif";